<template>
    <div class="float-left mr-1">
        <span class="text-gray">
            <i
                class="fa fa-clone fa-lg icon-button"
                title="Copiar"
                @click.stop="confirmarCopiar()"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        comprometimento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarCopiar() {
            this.$swal({
                title: 'Copiar',
                html: `Confirma a copia do comprometimento do id ${this.comprometimento.idComprometimento} do 
                contrato ${this.contrato.vcCodigoEstruturado} no RM?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.copiar()
                }
            })
        },

        copiar() {
            this.$emit('copiar', this.comprometimento.idComprometimento)
        }
    }
}
</script>
